export const IS_MOBILE = window.innerWidth < 800;
